export default function ({ route, redirect, $logger }) {
  if (route.path !== "/" && route.path.endsWith("/")) {
    const { path, query, hash } = route;
    const nextPath = path.replace(/\/+$/, "") || "/";
    const nextRoute = { path: nextPath, query, hash };

    redirect(301, nextRoute);
  }
  if (process.server || process.env.DEPLOY_STAGE !== "production") {
    $logger.info(`[routerMiddleware] ${route.fullPath}`);
  }
}
